import axios from 'axios';
import React from 'react'
import { BASE_URL, FastAPI } from '../../constant';
import { handleFormatResponse, handleFormatResponseForError } from '../../utility';

export function useDashboardDate() {

const fetchDashboardData = async (endpoint: string) => {
    try {

        let response = await axios.get(`${FastAPI}home/${endpoint}`);
        // console.log("Response: ", response?.data);
        const formattedResponse = handleFormatResponse(response);
        return formattedResponse;

    } catch (error: any) {

        // console.log("Error: ", error);
        const formattedError = handleFormatResponseForError(error);
        return formattedError;

    };
}; 


const fetchDashboardDataNipun = async (endpoint: string, data: any) => {
  try {
    let response = await axios.post(`${BASE_URL}DashboardReport/${endpoint}`, data);
    // console.log("Response: ", response?.data);
    const formattedResponse = handleFormatResponse(response);
    return formattedResponse;
  } catch (error: any) {
    // console.log("Error: ", error);
    const formattedError = handleFormatResponseForError(error);
    return formattedError;
  }
};

const getDashboardDataNipun = async (endpoint: string) => {
  try {
    let response = await axios.get(
      `${BASE_URL}DashboardReport/${endpoint}`
    );
    // console.log("Response: ", response?.data);
    const formattedResponse = handleFormatResponse(response);
    return formattedResponse;
  } catch (error: any) {
    // console.log("Error: ", error);
    const formattedError = handleFormatResponseForError(error);
    return formattedError;
  }
};

   const putDashboardDataNipun = async (endpoint: string, payload: any) => {
     try {
       let response = await axios.put(
         `${BASE_URL}DashboardReport/${endpoint}`,
         payload,
       );
       // console.log("Response: ", response?.data);
       const formattedResponse = handleFormatResponse(response);
       return formattedResponse;
     } catch (error: any) {
       // console.log("Error: ", error);
       const formattedError = handleFormatResponseForError(error);
       return formattedError;
     }
   };

const fetchDashboardDataStaging = async (endpoint: string) => {
    try {

        let response = await axios.get(`${endpoint}`);
        // console.log("Response: ", response?.data);
        const formattedResponse = handleFormatResponse(response);
        return formattedResponse;

    } catch (error: any) {

        // console.log("Error: ", error);
        const formattedError = handleFormatResponseForError(error);
        return formattedError;

    };
}; 

const saveDashboardFormData= async (endpoint: string,data:any) => {
    try {

        let response = await axios.post(`${endpoint}`,data,{
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        // console.log("Response: ", response?.data);
        const formattedResponse = handleFormatResponse(response);
        return formattedResponse;

    } catch (error: any) {

        // console.log("Error: ", error);
        const formattedError = handleFormatResponseForError(error);
        return formattedError;

    };
};

const deleteDashboardDataStaging = async (endpoint: string) => {
    try {

        let response = await axios.delete(`${endpoint}`);
        // console.log("Response: ", response?.data);
        const formattedResponse = handleFormatResponse(response);
        return formattedResponse;

    } catch (error: any) {

        // console.log("Error: ", error);
        const formattedError = handleFormatResponseForError(error);
        return formattedError;

    };
};


return {
  fetchDashboardData,
  fetchDashboardDataStaging,
  saveDashboardFormData,
  deleteDashboardDataStaging,
  fetchDashboardDataNipun,
  getDashboardDataNipun,
  putDashboardDataNipun,
};
}
